
export default {
  selectHomePortletList: { // 홈 화면 포틀릿 목록 조회
    method: 'GET',
    url: 'mrm/v1/ignore/nrw/home/portletList'
  },
  selectPortletDataForType: { // 포틀릿 타입으로 데이터 조회를 수행
    method: 'GET',
    url: 'mrm/v1/ignore/nrw/home/selectPortletDataForType'
  },
  selectUserCurationTabCorsList: { // 사용자 정의 큐레이션의 탭 데이터 조회
    method: 'GET',
    url: 'mrm/v1/ignore/nrw/home/selectUserCurationTabCorsList'
  }

}



// WEBPACK FOOTER //
// ./src/config/router/nrw/api/homeApi.js